import moment from 'moment';
type Product = {
    provider_start_date: string | null,
    provider_end_date: string | null,
    client_start_time: string | null,
    client_end_time: string | null,
    client_start_date: string | null,
    client_end_date: string | null,
    start_date: string | null,
    end_date: string | null
}

export function addProviderDates<T extends Product>(item: T): T {
    const result = { ...item };
    const defaultDate = moment.utc(result.start_date ?? undefined).toISOString();

    if (!result.provider_start_date || !result.provider_end_date) {
        result.provider_start_date = result.start_date;
        result.provider_end_date = result.end_date ?? result.start_date;
    
        const startHour = moment.utc(result.client_start_time ?? '', 'HH:mm').isValid() ?
            result.client_start_time :
            moment.utc(result.start_date ?? undefined).format('HH:mm');
        const startDate = moment.utc(result.client_start_date ?? '', 'YYYY-MM-DD').isValid() ?
            result.client_start_date :
            moment.utc(result.start_date ?? undefined).format('YYYY-MM-DD');
        result.start_date = moment.utc(`${startDate} ${startHour}`, 'YYYY-MM-DD HH:mm').toISOString();

        const endHour = moment.utc(result.client_end_time ?? '', 'HH:mm').isValid() ?
            result.client_end_time :
            moment.utc(result.end_date ?? defaultDate).format('HH:mm');
        const endDate = moment.utc(result.client_end_date ?? '', 'YYYY-MM-DD').isValid() ?
            result.client_end_date :
            moment.utc(result.end_date ?? defaultDate).format('YYYY-MM-DD');
        result.end_date = moment.utc(`${endDate} ${endHour}`, 'YYYY-MM-DD HH:mm').toISOString();
    }

    return result;
}
